var as_user_id = '';

export function setAsUserId(id) {
    as_user_id = id;
}

export function callAsync(params = {}) {
    if (params.hasOwnProperty('abortVar') && params.abortVar != null) {
        var abort = params.abortVar;
        if (window[abort] != null) {
            window[abort].abort();
            console.log('abort ajax');
            window[abort] = null;
        }
    } else {
        var abort = 'nokill';
    }
    if (
            params.hasOwnProperty('$target') &&
            params.hasOwnProperty('loadingMsg') &&
            params.loadingMsg != null
    ) {
        params.$target.html(params.loadingMsg);
    }
    var ajaxObject = {
        url: params.url + (params.url.indexOf('?') != -1 ? '&' : '?') + 'au=' + as_user_id ,
        type: 'post',
        dataType: 'json',
    };    
    if (params.hasOwnProperty('postData') && params.postData != null) {
        if (typeof params.postData == 'string' && $('#' + params.postData).length) {
            ajaxObject.data = new FormData($('#' + params.postData)[0]);
            ajaxObject.contentType = false;
            ajaxObject.processData = false;
        } else {
            ajaxObject.data = params.postData;
        }
    }
    ajaxObject.success = function (response) {
        if (params.hasOwnProperty('$target') && params.$target != null) {
            if (response.hasOwnProperty('html')) {
                if (params.hasOwnProperty('append') && params.append != null) {
                    params.$target.append(response.html);
                } else {
                    params.$target.html(response.html);
                }
            } else {
                if (params.hasOwnProperty('append') && params.append != null) {
                    params.$target.append(response);
                } else {
                    params.$target.html(response);
                }
            }        
        }
        if (params.hasOwnProperty('callback') && params.callback != null) {
            if (typeof params.callback === 'string' || params.callback instanceof String) {
                var cfunct = {function: params.callback};
                window[cfunct.function](response, (params.hasOwnProperty('caller') ? params.caller : null));
            } else {
                params.callback(response, (params.hasOwnProperty('caller') ? params.caller : null));
            }
        }
        if (response.hasOwnProperty('post_ajax_redirect')) {
            window.location.replace(response.post_ajax_redirect);
        }
        if (params.hasOwnProperty('disabledBtnId')) {
            $('#' + params.disabledBtnId).prop('disabled', false);
        }
    };
    ajaxObject.error = function (error) {
        console.log(error);
    };
    window[abort] = $.ajax(ajaxObject);
}
